enum Errors {
  COMPONENT_INSTANCE_NOT_CREATED = 'The component instance is not created yet',
  MISSING_CONTAINER = 'Please make sure that the container where you will render the widget exists',
  MISSING_CONTAINER_ID = 'Please provide a container id where the Spons Parkwhiz SDK should be placed',
}

export default Errors;
